// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper__V7WfUwb2IyZl","link":"link__K0gzzo5C2k9D","warning":"warning__pHRXv1QeefXq"};